<form [formGroup]="reportsEditForm">
  <div class="form-row row">
    <div class="col-12">
      <label for="reportType" class="control-label required">{{'i18n.domain.reports.filter.fields.reportType' | translate}}</label><br>
      <ejs-dropdownlist id="reportType"
                        formControlName="reportType"
                        [fields]="enumDropdownSettings"
                        [showClearButton]="true"
                        [dataSource]="types"></ejs-dropdownlist>
      <app-error-messages [control]="reportsEditForm.controls.reportType"></app-error-messages>
    </div>
  </div>
  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.TagsPerParker]">
    <app-tags-form [form]="reportsEditForm"></app-tags-form>
  </div>
  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerRegistrations]">
    <app-parker-registration-form [form]="reportsEditForm"></app-parker-registration-form>
  </div>
  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.FalseRecordings]">
    <app-false-recording-form [form]="reportsEditForm"></app-false-recording-form>
  </div>
  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerTurnover]">
    <app-parker-turnover-form [form]="reportsEditForm"></app-parker-turnover-form>
  </div>
  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerExtract]">
    <app-parker-extract-form [form]="reportsEditForm"></app-parker-extract-form>
  </div>
  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.DeviceStatus]">
    <app-device-status-form [form]="reportsEditForm"></app-device-status-form>
  </div>
<!--  <div *ngIf="reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerPerTariff]">-->
<!--    <app-parker-tariff-form [form]="reportsEditForm"></app-parker-tariff-form>-->
<!--  </div>-->
</form>
